<template>
  <div class="Info">
      <div class="main">
        <el-form ref="form" :model="form" label-width="80px">
          <section>
            <h2>基本信息</h2>

          <el-form-item label="头像" required>
              <div class="upload">
                  <upload class="avatar-uploader" :imgRule="imgRule"  @setImage="setCCoverfile" :uploadType="uploadType" ref="coverfile"></upload>
                  <p class="img-txt">点击头像选择您需要上传的图片，我们会自动生成缩略图。 仅支持 jpg、png、jpeg格式的图片文件、小于2MB</p>
                </div>

            </el-form-item>
            <el-form-item label="昵称" required>
              <el-input v-model="form.nickname"></el-input>
            </el-form-item>
            <el-form-item label="性别">
              <el-radio v-model="form.sex" label='1'>男</el-radio>
              <el-radio v-model="form.sex" label='2'>女</el-radio>
            </el-form-item>
            <el-form-item label="个人介绍">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="用一段话介绍你自己吧…"
                v-model="form.desp">
              </el-input>
            </el-form-item>

          </section>

          <section>
            <h2>联系信息</h2>
            <el-form-item label="真实姓名">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="常用邮箱">
              <el-input v-model="form.emai"></el-input>
              <p>用于接收来自平台的邮件通知</p>
            </el-form-item>
            <el-form-item label="手机号码">
              <el-input v-model="form.mobileno"></el-input>
              <p>用于提醒等服务，手机号不会对外公开，请放心</p>
            </el-form-item>
            <el-form-item label="QQ号码">
              <el-input v-model="form.qq"></el-input>
              <p>用于高效交流</p>
            </el-form-item>
            <el-form-item label="微信号">
              <el-input v-model="form.wxno"></el-input>
              <p>用于高效交流</p>
            </el-form-item>
          </section>
          <el-button type="primary" @click="updateUserCustomerInfo">立即提交</el-button>
        </el-form>
      </div>
  </div>
</template>

<script>
import {getUserCustomerInfo, updateUserCustomerInfo} from 'api/personalCenterApi'
import {mapActions, mapGetters} from 'vuex'
import Upload from 'views/pc/personalCenter/components/upload'
import $ from 'jquery'
export default {
  name: 'Info',
  data () {
    return {
      form: {
          headimgurl: '', //头像
          nickname: '', //昵称
          mobileno: '',//手机号
          sex: '1', //性别
          desp: '', //	个人简介
          name: '', //	真实姓名
          emai: '', //	邮箱
          qq: '', //	qq号
          wxno: '', //	微信号
        },
      uploadType: { // 图片参数
        catecode: '95',
        datatype: 'IMAGE'
      },
      imgRule: {  // 图片格式
        cls: 'icon_upload',
        accept: 'image/png,image/jpeg,image/jpg',
        size: 2,
        width: '',
        height: ''
      },
    }
  },
  mounted () {
    $('html').scrollTop(0)
    $('html').css("background", '#f8f8f8')
    if (!this.user().isLogin) {
      this.setLoginPop(true)
    } else {
      this.getUserCustomerInfo() // 获取用户基本信息
    }
  },
  destroyed() {
    $('html').css("background", '#fff')
  },
  methods: {
    setCCoverfile(list) {
      // console.log(list)
      delete list.type
      this.form.headimgurl = JSON.stringify(list)
    },
    getUserCustomerInfo() { // 获取用户基本信息
      this.setLoading(true)
      getUserCustomerInfo({ // 用户基本信息接口
        data: {},
        success: data => {
          this.setLoading(false)
          data.data.sex = data.data.sex.toString()
          this.form = data.data

          // 设置图片回填 coverfileShop
          this.$refs.coverfile.setImage(this.form.headimgurl)

          this.form.headimgurl = ''
        },
        error: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }

      })
    },
    updateUserCustomerInfo() {  // 修改用户基本信息

      if (this.form.nickname == '' || this.form.nickname.length == 0) {
        this.$message.error('昵称不能为空')
      } else {

        // 手机存在情况下 判断格式
        if (this.form.mobileno) {
          if(!(/^1[3456789]\d{9}$/.test(this.form.mobileno))){ 
            this.$message.error("手机号码有误，请重填");  
            return false; 
          } 
        }
        
        // 邮箱存在情况下 判断格式
        if (this.form.emai) {
          var reg = /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/
          if(!reg.test(this.form.emai)){
              this.$message.error("邮箱码有误，请重填");  
              return false; 
          }
        }

        this.setLoading(true)
            updateUserCustomerInfo({
              data: JSON.parse(JSON.stringify(this.form)),
              success: data => {
                this.setLoading(false)
                if (data.code == '000') {
                  this.$message.success('修改成功')

                  let user = JSON.parse(JSON.stringify(this.user()))
                    
                  // 更新session 登录信息 登录头像
                  user.nickname = this.form.nickname
                  if (this.form.headimgurl !== '') {
                      user.logourl = JSON.parse(this.form.headimgurl).furl
                  } 
                  // 更新user
                  this.setUser(user)
                  window.sessionStorage.setItem('user', JSON.stringify(user))

                  // 刷新列表
                  this.getUserCustomerInfo() 
                } else {
                  this.$message.error(data.msg)
                }
              },
              error: data => {
                  this.setLoading(false)
                  this.$message.error(data.msg)
              }
           })
      }
    },
    ...mapActions(['setLoading', 'setUser', 'setLoginPop']),
    ...mapGetters(['user'])
  },
  filters: {},
  watch: {},
  computed: {},
  components: {
    Upload
  }
}
</script>

<style lang="scss" type="text/scss" scope>
.Info {
  position: relative;
  .main {
      margin: auto;
      margin-top: 104px;
      padding: 30px;
      width: 1200px;
      box-sizing: border-box;
      background: #fff;
    }
  h2 {
    margin-bottom: 32px;
    font-size: 16px;
    font-weight: bold;
  }
  
  .el-form {
     .el-input {
        input {
          width: 244px;
        }
     }
     .el-textarea {
       textarea {
         width: 453px;
       }
     }
    // width: 523px;
    section:nth-child(1) .el-form-item:nth-child(2) .el-form-item__label{
      line-height: 80px;
    }

    p {
      font-size: 12px;
      color: #999;
    }
    .avatar-uploader {
      float: left;
    }
    .img-txt {
      float: left;
      width: 364px;
      margin-left: 20px;
      font-size: 14px;
    }
  }
  .el-button {
    display: block;
    margin: auto;
    margin-bottom: 20px;
  }

  .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 50%;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader {
      width: 76px;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 76px;
        height: 76px;
        line-height: 76px;
        text-align: center;
    }
    .avatar {
        width: 76px;
        height: 76px;
        display: block;
    }
}
</style>